import React from 'react';
import axios from 'axios';
import Navbar from '../Navbar';
import Footer from '../Footer';
import {
    WORDPRESS_URL,
    WP_CATEGORIES_SLUG,
    WP_POST_CATEGORIES_WITH_FEATUREDMEDIA
} from "../../utils/constants";
import Preloader from "../Preloader";
import renderHTML from "react-render-html";
import { Link, Redirect } from "react-router-dom";
import defaultBg from "../../images/category-clanek.jpg";
import kosodelnik from "../../images/kosodelnik.png";
import kosodelnikModry from "../../images/kosodelnik-modry.png";

class About extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            isLoading: true,
            actualitiesArray: [],
            error: {},
            redirectInternalError: false
        }
    }


    handleBack = () => {
        const { history } = this.props;
        if (document.referrer && document.referrer.includes(window.location.hostname)) {
          history.goBack();
        } else {
          history.push('/'); // nebo jiná stránka
        }
      };

    componentDidMount(){
        axios.get( WORDPRESS_URL + WP_CATEGORIES_SLUG + "o-spolecnosti")
        .then(response_slug => {
            if (response_slug !== undefined) {
                axios.get( WORDPRESS_URL + WP_POST_CATEGORIES_WITH_FEATUREDMEDIA + response_slug.data[0].id)
                .then(response_actualities => {
                    if (response_actualities !== undefined) {
                        const actualitiesArray = response_actualities.data.map(function (data, id){
                            let featuredMediaLinks = data._embedded['wp:featuredmedia'] ? data._embedded['wp:featuredmedia'] : null;
                            let featuredMediaLink = featuredMediaLinks ? `url("${featuredMediaLinks[0].source_url}")` : `url("${defaultBg}")`; //rest api na získání úvodního obrázku
                            return {
                                idx: id,
                                title: data.title.rendered,
                                text: data.content.rendered, 
                                shortText: data.excerpt.rendered,
                                slug: data.slug,
                                featuredMedia: featuredMediaLink
                            };
                        });
        
                        this.setState({
                            isLoading: false, 
                            actualitiesArray: actualitiesArray
                        }); 
                    }                    
                });
            }                                   
        })
        .catch( error => {
            console.log(error);  

            this.setState({ 
                error: error, 
                isLoading: false,
                redirectInternalError: true
            });       
        });
    }

    renderHeader = () => {
        return(
            <header className="company-header section-header">
                <div className="header-overlay">
                <Navbar/>
    
                <div className="sd-container">
                    <section id="section-sub-header">
                            <div className="col-md-12 d-flex justify-content-between section-title"> 
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="sub-header-caption text-uppercase title-border-radius link">O společnosti</h6>
                                    </div>
                                <span className='back-button link' onClick={this.handleBack}><i className='fa ml-2 fa-chevron-left'></i> Zpět</span>          
                            </div>                        
                    </section>
                </div>
                </div>
            </header> 
    );
}

    renderMainContainer = () => {
        return(
            <section id="main-container" className='mb-4'>
                <div className='sd-container'>
                    <section id="section-text"><h5 className='font-weight-bold mb-3'>PRODECO, a.s., IČ 25020790 je společnost, která vznikla dne 21.5 1997</h5> 
                    Společnost je universálním právním nástupcem VÍTKOVICE - PRODECO, spol. s r.o. Předmět jejího podnikání je zejména, projektová činnost ve výstavbě, obráběčství, zámečnictví, opravy strojů a montáže zařízení. Údaje o společnosti se zapisují do obchodního rejstříku vedeného Krajským soudem v Ústí nad Labem, v oddíle B, vložce 989.
<br/><br/>
Vytvoření projekční složky společnosti v Teplicích se však datuje již do roku 1945.,
<br/><br/>
Základní milníky v historii společnosti:
<ul>
<li>V roce 2008 se jediným akcionářem společností PRODECO, a.s. stávají Severočeské doly a. s.</li>
<li>V roce 2013 byla dokončena fúze sloučením se společností SD - 1.strojírenská, a.s. Touto fúzí společnost získala špičkové výrobní kapacity, díky kterým může poskytovat svým zákazníkům komplexnější služby.</li>
<li>Dne 01.07.2014 byla dokončena fúze sloučením se společností SD - KOMES, a.s.</li>
</ul>
Společnost PRODECO, a.s. je jako řízená osoba součástí koncernu řízeného společností ČEZ, a. s., jako řídící osobou. Toto oznámení je činěno v souladu s ustanovením § 79 odst. 3 zákona č. 90/2012 Sb., o obchodních korporacích, v platném znění.
                    </section>
                </div>
                <div className="sd-container-aktuality category">
                <div className="d-flex sd-container-aktuality-flex sd-container-category">
                        <div>
                        {this.renderArticles()} 
                        </div>                       
                    </div>
                </div>
            </section>
        );
    }

    renderArticles = () => {
        const { actualitiesArray } = this.state;

        const actualities = actualitiesArray.map((actuality, index) =>
            <Link to={`clanek/${actuality.slug}`}>
                            <div className="sd-category-article" key={index}>
                <div className="sd-category-article-image" style={{backgroundImage: actuality.featuredMedia }}>
            </div>
                    <div className="sd-category-article-body">
                        <div className="sd-article-title">{ renderHTML(actuality.title) }</div>
                        <div className="sd-article-content">{ renderHTML(actuality.shortText) }</div>
                        
                        <div className="sd-article-link"> 
                            <span className="pull-right sd-text-primary">
                                <b>Zjistit více</b>
                                <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </Link>
        );
    
        return actualities;
    }

    renderFooter = () => {
        return(
            <footer className="footer-section-height">
                <div className="sd-container">
                    <section id="footer-content" className="footer-top-padding footer-top-padding-contact">
                        <Footer/>
                    </section>
                </div>
            </footer>           
        );
    }

    render(){
        const { isLoading, redirectInternalError, error } = this.state;

        return (            
            <section id="web">
                {isLoading ? (
                    <Preloader isLoaded={!isLoading} />
                ) : (redirectInternalError ? (
                    <Redirect to={{
                        pathname: "/500",
                        state: { error: error }
                      }} />
                ) : ( 
                    <div className="wrapper">
                        {this.renderHeader()}

                        {this.renderMainContainer()}

                        {this.renderFooter()}
                    </div>
                ))}
            </section>        
        )
    }
}

export default About;